import type { Language } from './environment';
import { getLanguageFromUrl } from './environment';

/**
 * Language-specific Configuration
 */
export interface LanguageConfig {
  language: Language;
  apiUrl: string;
  gaTrackingId: string;
  currency: string;
  timezone: string;
  dateFormat: string;
  domain: string;
}

const LANGUAGE_CONFIGS: Record<Language, LanguageConfig> = {
  de: {
    language: 'de',
    apiUrl: import.meta.env.VITE_API_URL || 'https://api.samebi.net',
    gaTrackingId: import.meta.env.VITE_GA_TRACKING_ID || 'G-DE-XXXXXXXXX',
    currency: 'EUR',
    timezone: 'Europe/Berlin',
    dateFormat: 'DD.MM.YYYY',
    domain: 'burnout-test.samebi.net',
  },
  en: {
    language: 'en',
    apiUrl: import.meta.env.VITE_API_URL || 'https://en-api.samebi.net',
    gaTrackingId: import.meta.env.VITE_GA_TRACKING_ID || 'G-EN-XXXXXXXXX',
    currency: 'EUR',
    timezone: 'Europe/London',
    dateFormat: 'MM/DD/YYYY',
    domain: 'burnout-check.samebi.net',
  },
  es: {
    language: 'es',
    apiUrl: import.meta.env.VITE_API_URL || 'https://es-api.samebi.net',
    gaTrackingId: import.meta.env.VITE_GA_TRACKING_ID || 'G-ES-XXXXXXXXX',
    currency: 'EUR',
    timezone: 'Europe/Madrid',
    dateFormat: 'DD/MM/YYYY',
    domain: 'test-burnout.samebi.net',
  },
};

/**
 * Get current language configuration
 */
export const getLanguageConfig = (): LanguageConfig => {
  const lang = getLanguageFromUrl();
  return LANGUAGE_CONFIGS[lang];
};

export const currentLanguage = getLanguageConfig().language;
export const currentConfig = getLanguageConfig();





